/**
 * TextareaGrow
 * ======================================
 * - expand textarea height according to content
 */


const ELEMENTS = '.js-TextareaGrow'

class TextareaGrow {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    this.elements.forEach((el) => {
      el.addEventListener("input", event => {
        const target = event.currentTarget;

        target.style.height = '';
        target.style.height = 2 + target.scrollHeight + 'px'
    });

    })
  }
}

new TextareaGrow()
